import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5b31277e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "mapdiv" }

import { createApp, computed, ref, onMounted, watch } from 'vue'
import mapService, { BreatheLayer } from '@/utils/mapServices.js'
import VideoPop from '@/components/map/VideoPop.vue'
import { useMainStore } from '@/store/main'
import Bus from '@/config/Bus'
import { Api } from '@/api/publicApi'
import pinia from '@/store/index'
import { useRouter } from 'vue-router'



export default /*#__PURE__*/_defineComponent({
  __name: 'Map',
  setup(__props) {

const mainStore = useMainStore(pinia) //初始化store
const api = new Api()

const router = useRouter()
const breathe = ref(false)
const rotate = ref(false)
const vm = undefined

const topMenu = computed(() => {
  return mainStore.topMenu
})

watch(topMenu, (newVal, oldVal) => {
  if (topMenu.value == 'basic_profile') {
    mapService.closeWaterQuality()
    renderRiversByWaterQuality()
  } else if (topMenu.value == 'water_environment_pollution_manage') {
    renderRiversByWaterQualitySG()
  } else {
    {
      mapService.closeWaterQuality()
    }
  }
})

setInterval(() => {
  // eslint-disable-next-line no-undef
  ue.interface.poiClick = (val) => {
    // eslint-disable-next-line no-undef
    ue4('FlyTo', {
      Coordinate: val.coordinate,
      EleType: 1,
      Yaw: 0,
      Pitch: -60,
      Distance: 1000,
    })
    const data = JSON.parse(val.args)
    // let modalType
    // switch (data.layer) {
    //   case '饮用水源地':
    //     modalType = '饮用水源地'
    //     break
    //   case '水库':
    //     modalType = '水库'
    //     break
    //   case '自动监测断面':
    //     modalType = '自动监测断面'
    //     break
    //   case '手工监测断面':
    //     modalType = '手工监测断面'
    //     break
    //   case '水文站':
    //     modalType = '水文站'
    //     break
    //   case '河道视频监控':
    //     modalType = '河道视频监控'
    //   case '无人机':
    //     modalType = '无人机巡河'
    //     break
    //   default:
    // }
    // data.modalType = modalType
    mapClick(data)
  }
}, 3000)

const initMap = () => {
  mapService
    .initMap(
      {
        container: 'mapdiv',
        style: 'htScreen.json',
        center: [105.918014, 29.168635],
        projection: 'equirectangular',
        zoom: 10.5,
        minZoom: 9.8,
        pitch: 50,
        bearing: 0,
        antialias: true,
      },
      'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
    )
    .then((map: any) => {
      map.once('styledata', () => {
        if (router.currentRoute.value.name === 'manual_monitoring_section') {
          renderRiversByWaterQualitySG()
        } else {
          renderRiversByWaterQuality()
        }
      })
    })
}

// 根据水质等级渲染河流
const renderRiversByWaterQuality = () => {
  try {
    api.screen.getAutoSiteLastWaterLevelUsingPost({}).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        api.screen
          .getSgDmLastWaterLevelUsingPost({})
          .then((res2) => {
            if (res2.code === 200) {
              mapService.renderRiversByWaterQuality([...res.data, ...res2.data], 'zd')
            } else {
              mapService.renderRiversByWaterQuality(res.data, 'zd')
            }
          })
          .catch((e) => {
            mapService.renderRiversByWaterQuality(res.data, 'zd')
          })
      } else {
        api.screen.getSgDmLastWaterLevelUsingPost({}).then((res2) => {
          if (res2.code === 200) {
            mapService.renderRiversByWaterQuality(res2.data, 'sg')
          }
        })
      }
    })
  } catch (error) {
    api.screen.getSgDmLastWaterLevelUsingPost({}).then((res) => {
      if (res.code === 200) {
        mapService.renderRiversByWaterQuality(res.data, 'sg')
      }
    })
  }
}
// 根据水质等级渲染河流（手工）
const renderRiversByWaterQualitySG = () => {
  api.screen.getSgDmLastWaterLevelUsingPost({}).then((res) => {
    if (res.code === 200) {
      mapService.renderRiversByWaterQuality(res.data, 'sg')
    }
  })
}

// 地图点击
const mapClick = (data) => {
  // console.log(data)
  // ue4('Version', {}, (version) => {
  // });
  console.log('mapclick', data)
  const properties = data.data
  let VideoPopDetail
  let popupTemp
  switch (data.layer && data.layer.id) {
    case '在线巡河':
      if (data.layer.type === 'qxsy') {
        // this.userData = data.properties;
        // this.videoPopShow = true;
      } else {
        VideoPopDetail = createApp(VideoPop, {
          data: function () {
            return properties
          },
        }) // 实例化弹框组件
        const parent = document.createElement('div')
        const vm = VideoPopDetail.mount(parent)
        popupTemp = vm.$el
        popup = mapService.popup(
          [parseFloat(properties.jd), parseFloat(properties.wd)],
          popupTemp,
          'video-pop-box'
        )
      }
      break
    case 'sgjcdm':
      break
    case 'sx-水库': // 水库
    case 'zj-水库注记':
      data.category = 'sk'
      properties.id = properties.NAME
      break
    case 'sx-二级河流yy': // 河流
    case 'sx-二级河流':
    case 'sx-二级河流-12+':
    case 'zj-河流注记':
    case 'sx-支流线':
      // data.properties.category = 'hl';
      break
    case 'yd-乡镇-click': // 镇街
      Bus.emit('layersManageZJ', properties.NAME)
      break
    default:
  }
  console.log('mapClick点位点击', data.modalType)
  // 判断打开弹框类型
  if (data.modalType) {
    if (data.modalType == '在线巡河') {
      mapService.flyTo({
        center: [parseFloat(data.data.jd), parseFloat(data.data.wd)],
        zoom: 14,
      })
      VideoPopDetail = createApp(VideoPop, {
        data: properties,
      }) // 实例化弹框组件
      const parent = document.createElement('div')
      const vm = VideoPopDetail.mount(parent)
      popupTemp = vm.$el
      popup = mapService.popup(
        [parseFloat(properties.jd), parseFloat(properties.wd)],
        popupTemp,
        'video-pop-box'
      )
    } else {
      // components/Dialog/Dialog.vue
      console.log('emit showModal')
      Bus.emit('showModal', data)
    }
  }
}

//popup对象
let popup
// 地图点击
const mapClick2 = (data) => {
  console.log(data)
  // ue4('Version', {}, (version) => {
  // });
  const properties = data.data
  let VideoPopDetail
  let popupTemp
  switch (data.layer && data.layer.id) {
    case '在线巡河':
      if (data.layer.type === 'qxsy') {
        // this.userData = data.properties;
        // this.videoPopShow = true;
      } else {
        VideoPopDetail = createApp(VideoPop, {
          data: function () {
            return properties
          },
        }) // 实例化弹框组件
        const parent = document.createElement('div')
        const vm = VideoPopDetail.mount(parent)
        popupTemp = vm.$el
        mapService.popup(
          [parseFloat(properties.jd), parseFloat(properties.wd)],
          popupTemp,
          'video-pop-box'
        )
      }
      break
    case 'sgjcdm':
      break
    case 'sx-水库': // 水库
    case 'zj-水库注记':
      data.category = 'sk'
      properties.id = properties.NAME
      break
    case 'sx-二级河流yy': // 河流
    case 'sx-二级河流':
    case 'sx-二级河流-12+':
    case 'zj-河流注记':
    case 'sx-支流线':
      // data.properties.category = 'hl';
      break
    case 'yd-乡镇-click': // 镇街
      Bus.emit('layersManageZJ', properties.NAME)
      break
    default:
  }

  // 判断打开弹框类型
  if (data.modalType) {
    if (data.modalType == '在线巡河') {
      VideoPopDetail = createApp(VideoPop, {
        data: properties,
      }) // 实例化弹框组件
      const parent = document.createElement('div')
      const vm = VideoPopDetail.mount(parent)
      popupTemp = vm.$el
      mapService.popup(
        [parseFloat(properties.jd), parseFloat(properties.wd)],
        popupTemp,
        'video-pop-box'
      )
    } else {
      // components/Dialog/Dialog.vue
      Bus.emit('2showModal', data)
    }
  }
}

Bus.on('closePopup', () => {
  popup && popup.remove()
})

const clickMapOutside = () => {
  popup && popup.remove()
}

// initMap()
onMounted(() => {
  Bus.on('mapClick', (data) => {
    mapClick(data)
  })
  Bus.on('mapClick2', (data) => {
    mapClick2(data)
  })

  initMap()
})

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, null, 512)), [
    [_directive_click_outside, clickMapOutside]
  ])
}
}

})